// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PlansListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PlansListInput — query params for GET /subscriptions/plans.
 *
 * Optional:
 *   include_inactive — when 1, inactive (active=0) plans are included in the
 *                      staff list so they can be reactivated (D3). Default
 *                      (absent/0) keeps the active-only behavior. Superseded
 *                      plan versions are never included regardless of the flag.
 */
import { registerContract } from './validate'

export interface Subscriptions_PlansListInput {
include_inactive?: number
}

registerContract('Subscriptions_PlansListInput', {
  include_inactive: { type: 'number',  required: false },
})
